import React from 'react';
import {cssBEM} from './index.jsx';
import Card from './Card.jsx';
import {FormattedHTMLMessage} from 'react-intl';

const CardsList = ({ cards, disabled, onAddClicked, showAllMode, values, ...rest}) => {

  const cardsToShow = showAllMode ? cards : values.map(vid => cards.find(card => card.id === vid)).filter(v => v !== undefined);

  return (
    <div className={`${cssBEM}__list`}>
      { cardsToShow.map((card, index) =>
        <Card
          {...rest}
          card={card}
          isActive={showAllMode ? values.includes(card.id) : true}
          key={index}
          onAddClicked={onAddClicked}
          disabled={disabled}
        />)
      }

      { showAllMode || disabled ? null :
        <button type="button" className={`${cssBEM}__btn ${cssBEM}__btn--addCardOptions`} onClick={onAddClicked} role="button" aria-label="Add Card">
          <FormattedHTMLMessage id='cardBuilder.addCard' />
        </button>
      }
    </div>
  );
};

export default CardsList;
